module.exports = __webpack_public_path__ + "static/img/28.605dae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/28.png
// module id = RPKZ
// module chunks = 1